module.exports = __webpack_public_path__ + "img/lipin.b3acea43.png";